import React from 'react';
import type { CaseEntryTotals } from '../../../utils/caseEntries';
import type { EstimateTotals } from '../../../utils/caseEstimate';
import { diffTone, signedKr } from '../../../utils/caseEstimate';
import { formatKr } from '../../../utils/quote';
interface CaseSummaryPanelProps {
  estimate: EstimateTotals | null;
  actual: CaseEntryTotals;
}
function Row({
  label,
  value,
  strong = false
}: {
  label: string;
  value: string;
  strong?: boolean;
}) {
  return <div className="flex justify-between gap-3 py-1" data-id="element-102" data-mp="25zte4jnkuqs5">
      <dt className={strong ? 'font-semibold text-ink' : 'text-ink-soft'} data-id="element-103" data-mp="2ato4u71lo60q">{label}</dt>
      <dd className={`whitespace-nowrap ${strong ? 'font-medium text-ink' : 'text-ink'}`} data-id="element-104" data-mp="1x1rdi57ra05e">{value}</dd>
    </div>;
}
function Heading({
  children
}: {
  children: React.ReactNode;
}) {
  return <p className="text-xs font-semibold uppercase tracking-wider text-ink-muted" data-id="element-105" data-mp="1n3bqoefrhd1p">{children}</p>;
}

/** Estimeret (tilbud) over for registreret (sag) — beløb ekskl. moms. */
export function CaseSummaryPanel({
  estimate,
  actual
}: CaseSummaryPanelProps) {
  const difference = estimate ? actual.subtotal - estimate.subtotal : 0;
  return <aside className="xl:sticky xl:top-24 xl:self-start" aria-label="Økonomi på sagen" data-id="element-106" data-mp="kzjuw42r9nvk">
      <div className="rounded-xl border border-line bg-canvas p-4 text-[15px]" data-id="element-107" data-mp="yz1oqxuwrrbs">
        {estimate && <>
            <Heading data-id="element-108" data-mp="u1jd2zpiay03">Estimeret</Heading>
            <dl className="mt-1.5" data-id="element-109" data-mp="6bfdd3ffvied">
              <Row label="Timer" value={formatKr(estimate.hours)} data-id="element-110" data-mp="6cgxryichh8r" />
              <Row label="Materialer" value={formatKr(estimate.materials)} data-id="element-111" data-mp="2a3t7dfc3pdk" />
              {estimate.other > 0 && <Row label="Øvrigt" value={formatKr(estimate.other)} data-id="element-112" data-mp="g0yw8935jc98" />}
              <Row label="Total ekskl. moms" value={formatKr(estimate.subtotal)} strong data-id="element-113" data-mp="g3bnjcusuyyy" />
            </dl>
            <div className="my-3 border-t border-line" data-id="element-114" data-mp="b8p9t318wubp" />
          </>}

        <Heading data-id="element-115" data-mp="3joiqpizho7ta">Registreret</Heading>
        <dl className="mt-1.5" data-id="element-116" data-mp="3erij33mzqx02">
          <Row label="Timer" value={formatKr(actual.hours)} data-id="element-117" data-mp="3eq7i1bkxk3cn" />
          <Row label="Materialer" value={formatKr(actual.materials)} data-id="element-118" data-mp="1io44s9a4upok" />
          <Row label="Kørsel / service" value={formatKr(actual.travelService)} data-id="element-119" data-mp="1im003p4etmn8" />
          <Row label="Andre omkostninger" value={formatKr(actual.other)} data-id="element-120" data-mp="1nlmcjwceyyuz" />
          <Row label="Total ekskl. moms" value={formatKr(actual.subtotal)} strong data-id="element-121" data-mp="1sdnofh5o6nkh" />
          <Row label="Moms" value={formatKr(actual.vatAmount)} data-id="element-122" data-mp="1xdiclcy28z1u" />
        </dl>
        <div className="mt-2 flex justify-between gap-3 border-t border-line pt-3" data-id="element-123" data-mp="zp88mseps183">
          <span className="font-semibold text-ink" data-id="element-124" data-mp="zrcp09tsusp9">Total inkl. moms</span>
          <span className="whitespace-nowrap font-display text-lg font-bold text-ink" data-id="element-125" data-mp="14oux5xzzt3w7">{formatKr(actual.total)}</span>
        </div>

        {estimate && <div className="mt-3 flex justify-between gap-3 rounded-lg bg-white px-3 py-2.5" data-id="element-126" data-mp="1dord9b8bgufn">
            <span className="text-ink-soft" data-id="element-127" data-mp="2l2utz03jkdf8">Forskel ekskl. moms</span>
            <span className={`whitespace-nowrap font-semibold ${diffTone(difference)}`} data-id="element-128" data-mp="2l4nppkcm9d8g">{signedKr(difference)}</span>
          </div>}
      </div>
    </aside>;
}